/** 丸の色。意味ではなく色の役割で指定し、状態との対応付けは呼び出し側が持つ。 */
export type StatusDotTone = "info" | "success" | "warning" | "danger" | "muted" | "disabled";

const TONE_CLASS: Record<StatusDotTone, string> = {
	info: "bg-accent",
	success: "bg-success",
	warning: "bg-warning",
	danger: "bg-danger",
	muted: "bg-fg-3",
	disabled: "bg-fg-4",
};

const PULSE = "animate-[izanagi-pulse_1.8s_ease-in-out_infinite]";
const PING = "animate-[izanagi-ping_1.8s_cubic-bezier(0,0,0.2,1)_infinite]";

interface StatusDotProps {
	tone: StatusDotTone;
	/** 進行中を示す明滅。 */
	pulse?: boolean;
	/** 稼働中を示す、丸から広がる波紋。 */
	ping?: boolean;
	tooltip?: string;
	testId?: string;
	/** テストから状態名で引くための印。 */
	state?: string;
}

/**
 * 状態を示す小さな丸。ツール行 (ToolEntry)・左ペインのチャット一覧・メッセージの送信状態・リソースのカードで、色・大きさ・明滅を揃える。
 * 色トークンやパルスを変えるときはここだけを直せばすべてに効く。
 */
export function StatusDot({
	tone,
	pulse = false,
	ping = false,
	tooltip,
	testId,
	state,
}: StatusDotProps) {
	if (ping) {
		return (
			<span
				data-testid={testId}
				data-state={state}
				data-tooltip={tooltip}
				className="relative grid shrink-0 place-items-center h-1.5 w-1.5"
			>
				<span className={`absolute inset-0 rounded-full ${TONE_CLASS[tone]} ${PING}`} />
				<span className={`rounded-full h-1.5 w-1.5 ${TONE_CLASS[tone]}`} />
			</span>
		);
	}
	return (
		<span
			data-testid={testId}
			data-state={state}
			data-tooltip={tooltip}
			className={`shrink-0 rounded-full h-1.5 w-1.5 ${TONE_CLASS[tone]}${pulse ? ` ${PULSE}` : ""}`}
		/>
	);
}
